module.exports = __webpack_public_path__ + "img/ListPlaceholder.dc1e39d8.svg";